<script lang="ts">
    import { fly } from "svelte/transition";
    import LL from "../../../../i18n/i18n-svelte";
    import { gameManager } from "../../../Phaser/Game/GameManager";
    import { isMobileOnboarding } from "../../../Stores/OnboardingStore";

    interface Props {
        onnext?: () => void;
    }

    const { onnext }: Props = $props();

    const worldName = gameManager.getCurrentGameScene()?.room?.roomName ?? "Куб.Мета";

    function handleNext() {
        onnext?.();
    }
</script>

<!-- Mobile onboarding: panel at bottom. Desktop: panel on the right. -->
<div
    class="z-3001 pointer-events-auto {$isMobileOnboarding
        ? 'fixed left-4 right-4 bottom-[4.5rem]'
        : 'fixed left-1/2 top-20 transform -translate-x-1/2'}"
>
    <div
        data-testid="onboarding-card"
        class="bg-mlight/80 shadow-light rounded-md2 backdrop-blur-lg p-4 sm:p-6 w-full max-w-[550px] border border-white/20 {$isMobileOnboarding
            ? 'mx-auto max-h-[50vh] overflow-y-auto'
            : ''}"
        in:fly={{ y: $isMobileOnboarding ? 10 : 10, duration: 400 }}
    >
        <div class="text-center">
            <h2 class="text-lg sm:text-[32px] sm:leading-7 font-bold text-mdark mb-3">
                {$LL.onboarding.complete.title()}
            </h2>
            <p class="text-base text-mdark/90 m-0">
                {$LL.onboarding.complete.description({ worldName })}
            </p>
            <div class="flex justify-center pt-5">
                <button
                    class="px-5 py-3 bg-mblue hover:bg-mblue-darker text-white rounded-lg font-medium transition-all text-[13px]"
                    onclick={handleNext}
                >
                    {$LL.onboarding.complete.finish()}
                </button>
            </div>
        </div>
    </div>
</div>
